import {
  db,
} from '@/plugins/firebase';

export const COLLECTIONS = {
  USERS: 'users',
  ROLES: 'roles',
  ISSUES: 'issues',
  CONTACTS: 'contacts',
  PROJECTS: 'projects',
  PROJECT_TYPES: 'projectTypes',
  PROJECT_STAGES: 'projectStages',
  PROJECT_FEATURES: 'projectFeatures',
  PROJECT_PLANS: 'projectPlans',
  EXPENSES: 'expenses',
};

export default {
  usersCollection: () => db.collection(COLLECTIONS.USERS),
  rolesCollection: () => db.collection(COLLECTIONS.ROLES),
  projectsCollection: () => db.collection(COLLECTIONS.PROJECTS),
  issuesCollection: () => db.collection(COLLECTIONS.ISSUES),
  typesCollection: () => db.collection(COLLECTIONS.PROJECT_TYPES),
  stagesCollection: () => db.collection(COLLECTIONS.PROJECT_STAGES),
  featuresCollection: () => db.collection(COLLECTIONS.PROJECT_FEATURES),
  plansCollection: () => db.collection(COLLECTIONS.PROJECT_PLANS),
  contactsCollection: () => db.collection(COLLECTIONS.CONTACTS),
  estimatesCollection: (state, getters, rootState) => db.collection(`users/${rootState.user.uid}/estimates`),
  milestonesCollection: (state, getters, rootState) => db.collection(`users/${rootState.user.uid}/milestones`),
  timesheetsCollection: (state, getters, rootState) => db.collection(`users/${rootState.user.uid}/timesheets`),
  statsCollection: (state, getters, rootState) => db.collection(`users/${rootState.user.uid}/stats`),
  dashboardStats: (state, getters, rootState) => db.collection(`users/${rootState.user.uid}/stats`).doc('dashboard'),
  expensesCollection: () => db.collection(COLLECTIONS.EXPENSES),
  uniqueId: (state, getters) => collection => getters[collection].doc().id,
  commonStoreData: (state, getters, rootState) => (data) => {
    const now = new Date();
    let roles = {};
    let createdAt = now;

    if (data.roles) {
      ({ roles } = data);
    }

    if (!roles[rootState.user.uid]) {
      roles[rootState.user.uid] = 'owner';
    }

    if (data.createdAt) {
      ({ createdAt } = data);
    }

    return {
      createdAt,
      modifiedAt: now,
      roles,
    };
  },
  commonUserData: (state, getters, rootState) => (data) => {
    const now = new Date();
    const userId = !data.userId ? rootState.user.uid : data.userId;
    let createdAt = now;

    if (data.createdAt) {
      ({ createdAt } = data);
    }

    return {
      createdAt,
      modifiedAt: now,
      userId,
    };
  },
  commonCreatorData: (state, getters, rootState) => (data) => {
    const now = new Date();
    const creatorId = !data.creatorId ? rootState.user.uid : data.creatorId;
    let createdAt = now;

    if (data.createdAt) {
      ({ createdAt } = data);
    }

    return {
      createdAt,
      modifiedAt: now,
      creatorId,
    };
  },
  categories: state => state.categories_list,
  projects: state => state.projects_list,
  features: state => state.features_list,
  stages: state => state.stages_list,
  plans: state => state.plans_list,
  contacts: state => state.contacts_list,
  estimates: state => state.estimates_list,
  timesheets: state => state.timesheets_list,
  expenses: state => state.expenses_list,
  roles: state => state.roles_list,
  users: state => state.users_list,
};
